var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnevlop2Icon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 51,
  fill: "none",
  viewBox: "0 0 75 51",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M6.25 2.063h62.5s4.688 0 4.688 4.687v37.5s0 4.688-4.688 4.688H6.25s-4.687 0-4.687-4.688V6.75s0-4.687 4.687-4.687"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M64.063 14.563 37.5 31.75 10.938 14.563M10.938 38l10.937-6.25M64.063 38l-10.938-6.25"
})));
export { SvgEnevlop2Icon as ReactComponent };
export default __webpack_public_path__ + "assets/images/enevlop2Icon.svg";